import { InputText } from "../Components/Form/Input";

export function clamp(num: number, min: number, max: number) {
    return Math.min(Math.max(num, min), max);
}

export function formatThousandSeparator(element: InputText) {
    const numberFormatter = new Intl.NumberFormat("de-DE");
    const elementValue = element.value;
    const elementValueWithoutThousandSeparator = Number(elementValue.replaceAll(/\./g, ""));
    const min = Number(element.min);
    const max = Number(element.max);

    if (elementValue) {
        let value = numberFormatter.format(Number(element.value.replaceAll(/\./g, "").replace(/,/g, ".")));

        if (elementValueWithoutThousandSeparator >= max) {
            value = numberFormatter.format(max);
        } else if (elementValueWithoutThousandSeparator <= min) {
            value = numberFormatter.format(min);
        }

        element.value = value !== "NaN" ? value : "0";
        element.validate();
    }
}
